import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from "./type";
import { goBack, navFaq, navNext, needHelp } from "./action";
import { addCommasToNumber, getDaysDelta, mockCurrentDate } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader, initializeFirebase } from "../../../configs/config";
import sharedPropsService from "../../../SharedPropsService";
import moment from "moment/moment";
import SharedPropsService from "../../../SharedPropsService";
export const template = (height, actualLoanAmount, chargesData, loanExpiryDays, tenureInDays, isRenewalAfterExpiry, lenderId) => ({
    layout: {
        id: ROUTE.LOAN_RENEWAL_LANDING_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'loanRenewalLandingPage', type: WIDGET.LOAN_RENEWAL_LANDING_PAGE }
        ],
    },
    datastore: {
        loanRenewalLandingPage: {
            chargesData: chargesData,
            loanExpiryDays: loanExpiryDays,
            actualLoanAmount: actualLoanAmount
                ? addCommasToNumber(actualLoanAmount)
                : addCommasToNumber(0),
            height: height,
            isRenewalAfterExpiry: isRenewalAfterExpiry,
            faqAction: {
                type: ACTION.GO_TO_FAQ,
                routeId: ROUTE.LOAN_RENEWAL_LANDING_PAGE,
                payload: {
                    tenureInDays: tenureInDays
                }
            },
            ctaAction: {
                type: ACTION.NAV_NEXT,
                routeId: ROUTE.LOAN_RENEWAL_LANDING_PAGE,
                payload: {}
            },
            needHelpAction: {
                routeId: ROUTE.LOAN_RENEWAL_LANDING_PAGE,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_getPortfolioScreen_needHelp_test' }
            },
            goBackAction: {
                routeId: ROUTE.LOAN_RENEWAL_LANDING_PAGE,
                type: ACTION.GO_BACK,
                payload: { id: 'bt_getPortfolioScreen_goBack_test_12' }
            },
            lenderId
        }
    },
});
export const loanRenewalLandingPage = {
    onLoad: async ({ network, getHeight }, { actualLoanAmount, loanExpiryDays }) => {
        await initializeFirebase();
        const loanRenewalDataFromSharedProp = await sharedPropsService.getLoanRenewalData();
        let isRenewalAfterExpiry = await sharedPropsService.getIsRenewalAfterExpiry();
        const config = await SharedPropsService.getFirebaseConfig();
        const loan_renewal_test_flag = config?.loan_renewal_test_flag;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        const currentMoment = (loan_renewal_test_flag === true || loan_renewal_test_flag === 'true') ? await mockCurrentDate() : moment().startOf('day').unix() * 1000;
        let _actualLoanAmount = actualLoanAmount ? actualLoanAmount : loanRenewalDataFromSharedProp?.actualLoanAmount;
        let _loanExpiryDays = loanExpiryDays ? loanExpiryDays : loanRenewalDataFromSharedProp?.loanExpiryDays;
        let _tenureInDays = loanRenewalDataFromSharedProp?.tenureInDays;
        if (_actualLoanAmount &&
            _loanExpiryDays &&
            _tenureInDays) {
            //do nothing as we already have data from cache
        }
        else {
            //make a call to user
            const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
            if (userContextResponse?.status === 200) {
                await sharedPropsService.setUser(userContextResponse?.data);
                const getCreditResponse = await network.get(`${api.getCredit}/${userContextResponse.data.linkedCredits[0].creditId}`, {
                    headers: await getAppHeader(),
                });
                if (getCreditResponse?.status === 200) {
                    _actualLoanAmount = getCreditResponse?.data?.actualLoanAmount;
                    _tenureInDays = getCreditResponse?.data?.tenureInDays;
                    _loanExpiryDays = await getDaysDelta(getCreditResponse?.data?.renewalDate);
                    isRenewalAfterExpiry = currentMoment >= getCreditResponse?.data?.renewalDate;
                }
            }
        }
        const _user = await sharedPropsService.getUser();
        const lenderId = _user?.linkedCredits[0]?.lendingPartnerId;
        const creditId = _user?.linkedCredits[0]?.creditId;
        let chargesData;
        const getRenewalChargesDetails = await network.get(`${api.getRenewalChargesDetailsV2}${creditId}`, {
            headers: await getAppHeader()
        });
        if (getRenewalChargesDetails?.status === 200) {
            chargesData = getRenewalChargesDetails?.data;
        }
        return Promise.resolve(template(getHeight(), _actualLoanAmount, chargesData, _loanExpiryDays, _tenureInDays, isRenewalAfterExpiry, lenderId));
    },
    actions: {
        [ACTION.NAV_NEXT]: navNext,
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.GO_TO_FAQ]: navFaq
    },
};
